import { createFileRoute } from '@tanstack/react-router';

import { ParentOnboardingBatchesByIdPage } from '~pages/parents/csv-batch-processing/id/index';

const RouteComponent = () => {
  const { id } = Route.useParams();
  return <ParentOnboardingBatchesByIdPage batchId={id} />;
};

export const Route = createFileRoute(
  '/_auth/_layout/parents/csv-batch-processing/$id/',
)({
  component: RouteComponent,
});
